import React, { useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  Paper,
} from '@mui/material';
import CarouselBanner from '../components/CarouselBanner';
import EnquiryForm from '../components/EnquiryForm';

function HomeLoan() {
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);

  const handleEnquiryOpen = () => {
    setIsEnquiryOpen(true);
  };

  const handleEnquiryClose = () => {
    setIsEnquiryOpen(false);
  };

  return (
    <>
      <CarouselBanner onApplyClick={handleEnquiryOpen} />
      <EnquiryForm 
        open={isEnquiryOpen} 
        onClose={handleEnquiryClose} 
      />
      <Box>
        <Paper
          sx={{
            bgcolor: 'primary.main',
            color: 'white',
            py: 6,
            mb: 4,
          }}
        >
          <Container maxWidth="lg">
            <Typography variant="h3" gutterBottom>
              Home Loan Products
            </Typography>
            <Typography variant="h6">
              Find the perfect home loan that suits your needs
            </Typography>
          </Container>
        </Paper>

        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Grid container spacing={4}>
            {[
              {
                title: 'New Home Loan',
                description: 'Get loans up to ₹10 Crore with attractive interest rates',
                features: ['Quick approval', 'Minimal documentation', 'Flexible tenure'],
              },
              {
                title: 'Plot Loan',
                description: 'Finance your dream plot with competitive interest rates',
                features: ['Up to 85% funding', 'Quick disbursement', 'Simple process'],
              },
              {
                title: 'Home Improvement Loan',
                description: 'Renovate and upgrade your home with easy financing',
                features: ['No collateral required', 'Quick processing', 'Affordable EMIs'],
              },

                {
                title: 'Top Up Loan',
                description: 'Get additional funds on your existing home loan',
                features: ['No collateral required', 'Quick processing', 'Affordable EMIs'],
              },

                {
                title: 'Loan Against Property',
                description: 'Get funds by leveraging your property',
                features: ['Up to 60% of property value', 'Flexible tenure', 'Quick processing'],
              },

                {
                title: 'Home Loan Balance Transfer',
                description: 'Renovate and upgrade your home with easy financing',
                features: ['No collateral required', 'Quick processing', 'Affordable EMIs'],
              },

              
            ].map((product) => (
              <Grid item xs={12} md={4} key={product.title}>
                <Card sx={{ height: '100%' }}>
                  <CardContent>
                    <Typography variant="h5" gutterBottom>
                      {product.title}
                    </Typography>
                    <Typography color="text.secondary" paragraph>
                      {product.description}
                    </Typography>
                    <Box sx={{ mb: 2 }}>
                      {product.features.map((feature) => (
                        <Typography key={feature} component="div" sx={{ mb: 1 }}>
                          • {feature}
                        </Typography>
                      ))}
                    </Box>
                    <Button variant="contained" color="primary" onClick={handleEnquiryOpen}>
                      Apply Now
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default HomeLoan; 